import React, { useCallback, useContext, useEffect, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import get from 'lodash/get';

// GLOBAL FUNCTIONS
import { controlName, modalFunctions } from 'functions.js';

// GLOBAL HELPERS
import { RecordContext } from 'helpers/getRecordData';

// LOCAL COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// VARIABLES

// FORM COMPONENT
const ToggledItems = ({
  children,
  label,
  flagName,
  alwaysRenderChildren,
  ...props
}) => {

  // CONTEXT
  const { record = {} } = useContext(RecordContext) || {};
  const { values, setFieldValue } = useFormikContext() || {};

  // PROPS
  const { name, itemLabel } = props;

  // MEMOS
  const itemValues = useMemo(
    () => values[name],
    [name, values]
  )
  const toggleName = useMemo(
    () => controlName(flagName),
    [flagName]
  )
  const hasItems = useMemo(
    () => String(get(values, toggleName)) === 'true',
    [values, toggleName]
  )
  const flagValue = useMemo(
    () => record[flagName],
    [record, flagName]
  )
  
  // CALLBACKS
  const handleChange = useCallback(
    e => {
      if (e.target.value === 'false') { // Clicked No
        if (!itemValues?.every(e => e?.isDeleted === true)) {
          e.target.value = 'true'; // Then keep it Yes
          modalFunctions.add({
            type: 'dialog',
            title: 'Error',
            body: `Please remove all ${String(itemLabel).toLowerCase()}s.`,
            buttons: [<Button.Cancel label="Close" />]
          });
        } else {
          setFieldValue(toggleName, false);
        }
      } else {
        setFieldValue(toggleName, true);
      }
    },
    [itemValues, itemLabel, setFieldValue, toggleName]
  )

  // EFFECTS
  useEffect(
    () => {
      if (flagValue !== undefined) setFieldValue(toggleName, String(flagValue) === 'true')
    },
    [toggleName, flagValue, setFieldValue]
  )

  // RENDER
  return (<>
    <Form.YesNo
      name={toggleName}
      label={label}
      onChange={handleChange}
      numeric={false}
      required
    />
    {(alwaysRenderChildren || hasItems) && children}
  </>)
}

export default ToggledItems